import {RichTextField} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import {LayoutGroup, motion, AnimatePresence} from 'framer-motion'
import {Icon} from 'src/common/Icon'
import {maskStyles} from 'slices/AnimatedList/constants'
import cn from 'classnames'

type SideTextProps = {
  activeStyle: number
  content: RichTextField
}

export function ContainerSideText({activeStyle, content}: SideTextProps) {
  return (
    <div className="self-end md:text-right">
      <LayoutGroup>
        <motion.div
          layout
          initial={false}
          transition={{layout: {type: 'tween', duration: 0.5, ease: 'easeInOut'}}}
          className={cn(
            'relative inline-block overflow-hidden rounded-lg border-moss-white bg-moss-white/[10%]',
            'py-2.5 pl-2.5 pr-4 backdrop-blur-[40px] md:px-4 md:py-3',
          )}
        >
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={activeStyle}
              layout
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              transition={{duration: 0.3, delay: 0.5}}
              className="flex items-center gap-4"
            >
              <PrismicRichText
                field={content}
                components={{
                  paragraph: ({children}) => (
                    <span className="flex items-center text-[15px] font-medium leading-[19px] text-moss-white md:text-[18px] md:leading-normal md:tracking-[.54px]">
                      {children}
                    </span>
                  ),
                  strong: () => <div className="mx-2 h-[5px] w-[5px] rounded-[1px] bg-moss-white max-lg:hidden" />,
                }}
              />
              <div className="flex h-8 w-8 min-w-8 items-center justify-center rounded-[2px] bg-moss-white">
                <Icon name="arrow" className="h-2.5 w-2.5 -rotate-45 text-moss-black" />
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="pointer-events-none absolute inset-0 rounded-lg" style={maskStyles} />
        </motion.div>
      </LayoutGroup>
    </div>
  )
}
